module.exports = __webpack_public_path__ + "static/media/Profile-Photo.39a6cc1d.jpg";